import PropTypes from 'prop-types'
import { Fragment, memo } from 'react'

/**
 * The `SplitTextBasic`
 *
 * @param {object} props - the props
 * @returns {React.ReactElement} the element
 */
function SplitTextBasic (props) {
  const { content } = props
  const chars = Array.from(content.replace(/ /g, '\u00a0'))

  return (
    <Fragment>
      {chars.map((char, index) => (
        <span key={index}>{char}</span>
      ))}
    </Fragment>
  )
}

/** @type {object} */
SplitTextBasic.propTypes = {
  content: PropTypes.string
}

/** @type {object} */
SplitTextBasic.defaultProps = {
  content: ''
}

// Memoize
export default memo(SplitTextBasic)
